import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DnsRecord } from '@/types/domains';
import DnsTable from './DnsTable.tsx';

function InfoDialog({ 
  showInfo, 
  setShowInfo, 
  instructions } : { 
  showInfo: boolean, 
  setShowInfo: (open: boolean) => void, 
  instructions: DnsRecord[]
}) {
  return (
    <Dialog open={showInfo} onOpenChange={setShowInfo}>
      <DialogContent className="max-w-[60%] " >
        <DialogHeader>
          <DialogTitle>DNS Configuration</DialogTitle>
          
        </DialogHeader>
          <DnsTable items={instructions} />
      </DialogContent>
    </Dialog>
  )
}

export default InfoDialog;